export default "__VITE_ASSET__d40061a1__"